import { ISubscription } from "./Subscription";

export interface IUserSubscription {
  id: string;
  userId: string;
  subscriptionId: string;
  subscription: ISubscription;
  credits: number;
  usageCredits: number;
  stripeId: string;
  currentPeriodEnd: Date;
  currentPeriodStart: Date;
  cancelAt: Date | null;
  trialPeriodEnd: Date | null;
  status:
    | "active"
    | "canceled"
    | "incomplete"
    | "incomplete_expired"
    | "past_due"
    | "paused"
    | "trialing"
    | "unpaid";
  isDeleted: boolean;
  isFuture: boolean;
  isSuspended: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface IUserSubscriptionCancellationReason {
  id: string;
  reason: string;
  comment: string;
  rating: number | null;
  additionalComment: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface IUserSubscriptionCreditLog {
  id: string;
  userSubscriptionId: string;
  creditsActionValue: number;
  creditsAfterAction: number;
  type: UserSubscriptionCreditLogType;
  metadata: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum UserSubscriptionCreditLogType {
  ReservationDeduction,
  ReservationRefund,
  AddonTopUp,
  RenewSubscription,
  RolloverCredits,
}

export interface IUserSubscriptionCancelModel {
  reason: string;
  comment: string;
}
